import { render, staticRenderFns } from "./PointChart.vue?vue&type=template&id=25c37d78&scoped=true&"
import script from "./PointChart.vue?vue&type=script&lang=js&"
export * from "./PointChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c37d78",
  null
  
)

export default component.exports